<template>
  <div
    class="flex min-h-screen flex-col text-primary antialiased anchor-scrolling-none"
  >
    <div class="border-gray-200 border-b">
      <div
        class="mx-4 flex h-[4.375rem] items-center justify-center gap-1 md:container sm:gap-4"
      >
        <div class="flex h-8 flex-initial items-center lg:hidden">
          <LogoMobile />
        </div>
        <Logo class="ml-4 flex-initial" :width="138" :height="32" />
      </div>
    </div>
    <div class="mt-4 grow">
      <ErrorLayout :error="error" />
    </div>
  </div>
</template>

<script setup lang="ts">
const error = useError()

const { toLocalePath } = useRouteHelpers()
const { fetch: fetchGlobalConfig } = useGlobalConfig()

// error.vue renders outside the default layout, which is normally the only
// place global config (the anniversary flag) is loaded. ErrorLayout loads it
// too, but as a body component it resolves AFTER the header logo has already
// rendered — so on the server the logo emits its default variant while the
// client hydrates with the flag on (config is in the payload by then),
// producing a hydration mismatch that corrupts the logo SVG. Await it here,
// before the logo renders, so the anniversary flag is identical on server and
// client.
await fetchGlobalConfig()

onBeforeUnmount(() => {
  reloadNuxtApp({
    path: toLocalePath(routeList.home).toString(),
  })
})

defineOptions({ name: 'GlobalError' })
</script>
